import { render, staticRenderFns } from "./FormCotaParticipacao.vue?vue&type=template&id=c0db4f88"
import script from "./FormCotaParticipacao.vue?vue&type=script&lang=js"
export * from "./FormCotaParticipacao.vue?vue&type=script&lang=js"
import style0 from "./FormCotaParticipacao.vue?vue&type=style&index=0&id=c0db4f88&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports